import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateSolarFinancingLockReaders } from "./solar-financing-lock-readers"
import type { SolarExistingLoanApplicationDto } from "../dto/solar-proposal-financing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Record Credit Human's approval. Approval locks the Solar selections.
 */
export default function useMarkApprovedSolarCreditHuman(): UseMutationResult<
  SolarExistingLoanApplicationDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      solarProposalService.markCreditHumanApproved(proposalId, applicationId),
    // Fire and forget, as the Battery hooks do: the caller doesn't wait on refetches.
    onSettled: (_data, _error, { proposalId, applicationId }) => {
      invalidateSolarFinancingLockReaders(queryClient, proposalId)
      // Approval records a provider_decision event on the drawer's timeline.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.activeLoan.activity(applicationId),
      })
    },
  })
}
